export const brand = {
  name: 'SingleSystem',
  tagline: 'Automação • Integração • Inteligência Artificial',
  subtitle: 'Transformando processos em soluções digitais',
};

export const stats = [
  '28+ anos',
  'APIs',
  'React',
  'Java',
  'Oracle',
  'IA',
  'n8n',
];

export const problems = [
  { icon: '📄', title: 'Muitas planilhas', description: 'Dados espalhados sem controle nem versão única.' },
  { icon: '🔄', title: 'Retrabalho', description: 'A mesma informação digitada várias vezes no dia.' },
  { icon: '⏳', title: 'Aprovações lentas', description: 'Fluxos que travam porque dependem de pessoas e e-mail.' },
  { icon: '🔌', title: 'Sistemas isolados', description: 'ERP, RH e financeiro que não conversam entre si.' },
  { icon: '📧', title: 'E-mails', description: 'Processos inteiros rodando na caixa de entrada.' },
  { icon: '📋', title: 'Dados duplicados', description: 'Informações inconsistentes entre áreas e planilhas.' },
];

export const clientBenefits = [
  { icon: '⏱️', title: 'Economia de tempo', description: 'Sua equipe para de repetir tarefas e foca no que importa.' },
  { icon: '💰', title: 'Redução de custos', description: 'Menos retrabalho significa menos horas desperdiçadas.' },
  { icon: '📈', title: 'Mais produtividade', description: 'Processos digitais que fluem sem gargalos.' },
  { icon: '🔗', title: 'Integração', description: 'Todos os sistemas da empresa conectados e sincronizados.' },
  { icon: '🤖', title: 'IA', description: 'Inteligência Artificial aplicada onde faz diferença real.' },
  { icon: '📊', title: 'Dashboards', description: 'Indicadores claros para decisões mais rápidas.' },
];

export const solutions = [
  {
    icon: '💻',
    title: 'Sistemas',
    headline: 'Transforme processos manuais em sistemas rápidos e seguros',
    description: 'Portais, CRMs e sistemas corporativos desenvolvidos para a realidade da sua empresa.',
  },
  {
    icon: '⚡',
    title: 'Automação',
    headline: 'Elimine tarefas repetitivas e ganhe produtividade',
    description: 'Fluxos com n8n, IA e Microsoft 365 que rodam sozinhos, 24 horas por dia.',
  },
  {
    icon: '🔗',
    title: 'Integrações',
    headline: 'Faça seus sistemas conversarem entre si',
    description: 'Conectamos ERP, RH, financeiro e ferramentas do dia a dia via APIs.',
  },
  {
    icon: '🎯',
    title: 'Consultoria',
    headline: 'Descubra o melhor caminho antes de investir',
    description: 'Analisamos seus processos e indicamos a solução com melhor custo-benefício.',
  },
  {
    icon: '🧾',
    title: 'Contábil',
    headline: 'Fluxo NF-e — E-mail/API até ERP',
    description: 'Solução contábil: recebimento de NF-e por e-mail ou API, validação e integração automática com o ERP.',
  },
  {
    icon: '📨',
    title: 'Cobrança',
    headline: 'Fluxo Cobrança de Documentos Pendentes',
    description: 'Automação que identifica pendências e dispara cobranças por e-mail, com registro e acompanhamento.',
  },
];

export const realCases = [
  { slug: 'rh', area: 'RH', summary: 'Aprovações, férias e documentos sem e-mail nem planilha.' },
  { slug: 'financeiro', area: 'Financeiro', summary: 'Contas a pagar, notas fiscais e conciliação automatizada.' },
  { slug: 'comercial', area: 'Comercial', summary: 'Leads, propostas e contratos em um fluxo único.' },
  { slug: 'compras', area: 'Compras', summary: 'Solicitações, cotações e pedidos com aprovação digital.' },
  { slug: 'estoque', area: 'Estoque', summary: 'Movimentações com rastreabilidade em tempo real.' },
  { slug: 'producao', area: 'Produção', summary: 'Ordens, apontamentos e expedição integrados.' },
  { slug: 'contabil', area: 'Contábil', summary: 'NF-e de e-mail ou API até o ERP, com validação e rastreio.' },
  { slug: 'cobranca', area: 'Cobrança', summary: 'Cobrança automática de documentos pendentes com e-mail e controle.' },
];

export const useCases = {
  rh: {
    area: 'RH',
    title: 'Recursos Humanos',
    flow: ['Solicitação', 'Gestor', 'RH', 'Diretoria', 'Portal do Funcionário'],
    problem: [
      'Férias e benefícios aprovados por e-mail',
      'Planilhas para controle de documentos',
      'Funcionário sem visibilidade do status',
      'Histórico perdido em conversas',
    ],
    solution: [
      'Portal web com workflow de aprovação',
      'Notificações automáticas em cada etapa',
      'Histórico completo e auditável',
      'Self-service para o colaborador',
    ],
    benefits: [
      '80% menos tempo em aprovações',
      'Zero papel e zero e-mail para solicitações',
      'RH focado em pessoas, não em planilhas',
      'Conformidade e rastreabilidade total',
    ],
  },
  financeiro: {
    area: 'Financeiro',
    title: 'Financeiro',
    flow: ['Nota Fiscal', 'IA lê', 'Extrai dados', 'ERP', 'Pagamento'],
    problem: [
      'Notas fiscais digitadas manualmente',
      'Planilhas de contas a pagar desatualizadas',
      'Conciliação que consome horas',
      'Aprovações de pagamento por e-mail',
    ],
    solution: [
      'IA que lê e classifica documentos automaticamente',
      'Integração direta com o ERP',
      'Fluxo de aprovação digital',
      'Dashboard de vencimentos em tempo real',
    ],
    benefits: [
      'Redução drástica de erros de digitação',
      'Pagamentos no prazo, sem surpresas',
      'Visibilidade total para a diretoria',
      'Conciliação em minutos, não em dias',
    ],
  },
  comercial: {
    area: 'Comercial',
    title: 'Comercial',
    flow: ['Lead', 'CRM', 'Proposta', 'Contrato', 'Cliente'],
    problem: [
      'Leads perdidos em planilhas',
      'Cadastro duplicado de clientes',
      'Propostas sem padronização',
      'Contratos sem rastreabilidade',
    ],
    solution: [
      'CRM integrado ao ERP e financeiro',
      'Cadastro único com validação automática',
      'Geração de propostas padronizadas',
      'Fluxo digital até a assinatura do contrato',
    ],
    benefits: [
      'Nenhum lead esquecido',
      'Dados comerciais sempre atualizados',
      'Ciclo de venda mais curto',
      'Integração total com faturamento',
    ],
  },
  compras: {
    area: 'Compras',
    title: 'Compras',
    flow: ['Solicitação', 'Cotação', 'Aprovação', 'Pedido', 'Recebimento'],
    problem: [
      'Requisições por e-mail sem controle',
      'Cotações em planilhas paralelas',
      'Aprovações que demoram dias',
      'Pedido desconectado do recebimento',
    ],
    solution: [
      'Portal de solicitações com regras de negócio',
      'Cotação automática com fornecedores',
      'Aprovação hierárquica digital',
      'Integração com estoque e financeiro',
    ],
    benefits: [
      'Compras mais rápidas e transparentes',
      'Melhor negociação com histórico de preços',
      'Controle total do ciclo de compra',
      'Menos urgências e compras emergenciais',
    ],
  },
  estoque: {
    area: 'Estoque',
    title: 'Estoque',
    flow: ['Entrada', 'Movimentação', 'Inventário', 'Alerta', 'Reposição'],
    problem: [
      'Movimentações registradas em planilha',
      'Inventário manual e demorado',
      'Ruptura de estoque sem aviso',
      'Sem rastreabilidade de lotes',
    ],
    solution: [
      'Sistema web com leitura de código de barras',
      'Inventário cíclico automatizado',
      'Alertas de estoque mínimo',
      'Integração com compras e produção',
    ],
    benefits: [
      'Estoque sempre atualizado',
      'Menos perdas e obsolescência',
      'Reposição no momento certo',
      'Rastreabilidade completa por lote',
    ],
  },
  producao: {
    area: 'Produção',
    title: 'Produção',
    flow: ['Ordem', 'Apontamento', 'Qualidade', 'Estoque', 'Expedição'],
    problem: [
      'Ordens de produção em papel',
      'Apontamentos manuais com atraso',
      'Qualidade desconectada do chão de fábrica',
      'Expedição sem visão do estoque',
    ],
    solution: [
      'Painel de ordens de produção em tempo real',
      'Apontamento digital no chão de fábrica',
      'Checklist de qualidade integrado',
      'Expedição sincronizada com estoque',
    ],
    benefits: [
      'Produção visível para a diretoria',
      'Menos retrabalho e refugo',
      'Prazos de entrega mais confiáveis',
      'Integração total da fábrica',
    ],
  },
  contabil: {
    area: 'Contábil',
    title: 'Fluxo NF-e — E-mail/API até ERP',
    flow: ['E-mail ou API', 'Captura NF-e', 'Validação', 'Integração', 'ERP'],
    problem: [
      'Notas recebidas em e-mails e pastas sem padronização',
      'Digitação manual no ERP e risco de erro',
      'Atraso na entrada de documentos para a contabilidade',
      'Falta de rastreabilidade do que já foi importado',
    ],
    solution: [
      'Fluxo automatizado com recebimento por e-mail ou API',
      'Validação e organização das NF-e antes da integração',
      'Registro direto no ERP, sem retrabalho',
      'Solução contábil pensada para escritórios e departamentos fiscais',
    ],
    benefits: [
      'Menos digitação e mais produtividade',
      'Entrada de NF-e mais rápida e confiável',
      'Integração contínua entre canais e o ERP',
      'Controle e histórico do processamento',
    ],
  },
  cobranca: {
    area: 'Cobrança',
    title: 'Fluxo Cobrança de Documentos Pendentes',
    flow: ['Pendências', 'Regras', 'E-mail', 'Registro', 'Acompanhamento'],
    problem: [
      'Documentos pendentes esquecidos em planilhas ou e-mail',
      'Cobrança manual, repetitiva e sem padronização',
      'Gestores e clientes sem visão do que falta enviar',
      'Sem histórico de lembretes enviados',
    ],
    solution: [
      'Fluxo automatizado que identifica documentos pendentes',
      'Disparo de cobrança por e-mail conforme regras definidas',
      'Registro de cada envio para auditoria',
      'Integração com planilha ou sistema para acompanhamento contínuo',
    ],
    benefits: [
      'Menos pendências esquecidas',
      'Equipe livre de cobranças manuais repetitivas',
      'Comunicação padronizada e profissional',
      'Rastreabilidade de todos os lembretes',
    ],
  },
};

export const workflowSteps = [
  { icon: '🔍', title: 'Diagnóstico', description: 'Entendemos seus processos e identificamos oportunidades.' },
  { icon: '📐', title: 'Projeto', description: 'Definimos escopo, prazo e a melhor solução para o seu caso.' },
  { icon: '💻', title: 'Desenvolvimento', description: 'Construímos com entregas parciais e validação contínua.' },
  { icon: '🚀', title: 'Implantação', description: 'Colocamos em produção e treinamos sua equipe.' },
  { icon: '📈', title: 'Evolução', description: 'Acompanhamos e melhoramos conforme o negócio cresce.' },
];

export const costOfNotAutomating = [
  { role: 'Funcionários', impact: 'Gastam horas repetindo tarefas que um sistema faria em segundos.' },
  { role: 'Gestores', impact: 'Esperam aprovações que poderiam fluir automaticamente.' },
  { role: 'Financeiro', impact: 'Perde tempo com retrabalho em planilhas e conciliações manuais.' },
  { role: 'Diretoria', impact: 'Toma decisões sem indicadores confiáveis e em tempo real.' },
];

export const differentials = [
  'Atendimento direto com quem desenvolve',
  'Mais de 28 anos em tecnologia corporativa',
  'Soluções 100% sob medida para o seu processo',
  'Sem mensalidades — você é dono da solução',
];

export const technologies = [
  'Java', 'Spring Boot', 'React', 'Oracle', 'Docker',
  'REST APIs', 'Microsoft 365', 'n8n', 'OpenAI', 'Git',
];

export const technologiesDescription =
  'Utilizamos tecnologias modernas e consolidadas para criar soluções escaláveis e preparadas para o crescimento da sua empresa.';

export const articles = [
  { slug: 'eliminar-planilhas-excel', title: 'Como eliminar planilhas Excel', excerpt: 'Por que planilhas viram gargalo e como sua empresa pode sair delas.' },
  { slug: 'custo-processo-manual', title: 'Quanto custa um processo manual?', excerpt: 'O valor real do retrabalho que sua empresa paga todo mês.' },
  { slug: 'apis-rest', title: 'APIs REST', excerpt: 'Como conectar sistemas e eliminar silos de informação.' },
  { slug: 'ia-aplicada-rh', title: 'IA aplicada ao RH', excerpt: 'Como Inteligência Artificial transforma processos de pessoas.' },
  { slug: 'automatizando-compras', title: 'Automatizando Compras', excerpt: 'Do pedido ao recebimento sem e-mail nem planilha.' },
  { slug: 'integracao-erp-crm', title: 'Integração entre ERP e CRM', excerpt: 'Por que seus sistemas precisam conversar e como fazer isso.' },
];

export const diagnosticQuestions = [
  { id: 'excel', question: 'Sua empresa usa planilhas Excel para controlar processos?' },
  { id: 'email', question: 'Há processos importantes que dependem de e-mail?' },
  { id: 'approvals', question: 'Existem aprovações que demoram mais de 1 dia?' },
  { id: 'duplicate', question: 'A mesma informação é digitada em mais de um sistema?' },
  { id: 'isolated', question: 'Seus sistemas (ERP, RH, financeiro) não se comunicam?' },
  { id: 'reports', question: 'Relatórios gerenciais demoram para ficar prontos?' },
  { id: 'errors', question: 'Erros de digitação causam retrabalho frequente?' },
  { id: 'visibility', question: 'Gestores não têm visibilidade do status dos processos?' },
  { id: 'paper', question: 'Ainda existem processos com papel e assinatura física?' },
  { id: 'growth', question: 'O volume de trabalho manual cresce junto com a empresa?' },
];
